import { defineStore } from 'pinia'
import { useStoreConfig } from '~/store/storeConfig'

interface LanguageInterface {
  id: number | null
  iso_code: string | null
}

export const useLanguageStore = defineStore('language', {
  state: (): LanguageInterface => {
    return {
      id: null,
      iso_code: null,
    }
  },
  actions: {
    setLanguage(localeCode: string | null): void {
      if (localeCode) {
        const language = useStoreConfig().getSite?.languages?.find((lang) => lang.iso_code.toLowerCase() === localeCode)
        this.id = language?.id || null
        this.iso_code = language?.iso_code || null
      }
    },
  },
  getters: {
    getLanguageId(state): number | null {
      return state.id
    },
    getLanguageIso(state): string | null {
      return state.iso_code
    },
  },
})
